import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Button, Badge} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {Redirect} from 'react-router-dom';
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import './AccreditationRequestsList.css';
import RemoveAccreditationRequestModal
    from "../removeAccreditationRequetsModal/RemoveAccreditationRequestModal.container";
import {ACCREDITATION_REQUEST_STATUSES} from "../../../constants/constants";
import {REQUEST_SUBMITTED, REQUEST_IN_PROCESS, REQUEST_REJECTED} from "../../../reducers/applicantAccreditations/accreditationRequests";
import moment from "moment";
import AccreditationRequestDataModal from "../accreditationRequestDataModal/AccreditationRequestDataModal.container";

const STATUS_COLOR = {
    [REQUEST_SUBMITTED]: "secondary",
    [REQUEST_REJECTED]: "danger",
    [REQUEST_IN_PROCESS]: "warning",
};

const SUCCESS_MESSAGE_BY_ACTION = {
    EDIT: 'accreditation_requests.edit_accreditation_request_success_message',
    REMOVE: 'accreditation_requests.remove_accreditation_request_success_message'
}

class AccreditationRequestsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            selectedAccreditationRequestId: null,
            accreditationRequestToRemove: null,
            successMessage: null
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUpdate(nextProps) {
        if (_.isNil(this.props.accreditationRequest) && !_.isNil(nextProps.accreditationRequest)) {
            this.props.onShowAccreditationRequestModal();
        }
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to='/create-accreditation-request' push/>
            );
        }

        if (!_.isNil(this.state.selectedAccreditationRequestId)) {
            return (
                <Redirect to={'/edit-accreditation-request?id=' + this.state.selectedAccreditationRequestId} push/>
            );
        }

        return (
            <div className='accreditation-request-list-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, this.state.successMessage)}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'accreditation_requests.accreditation_requests_label')}</h4>
                    <div className='add-accreditation-request-container'>
                        <Button className='olive-green-btn' onClick={this.handleAddButtonClick}>
                            {_.get(this.props.translation, sharedLabelsPath.add_button)}
                        </Button>
                    </div>
                    {this.renderTable()}
                    <RemoveAccreditationRequestModal data={this.state.accreditationRequestToRemove}
                                                     onCancelRemoving={this.handleCloseModal}/>
                    <AccreditationRequestDataModal data={this.props.accreditationRequest}/>
                </FormWrapper>
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="accreditation-requests-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="accreditation-requests-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'accreditation_requests.accreditation_requests_no_data_label')}</h6>
                </div>
            );
        }

        return [
            <div className="accreditation-requests-list-relative-header"
                 key="accreditation-requests-list-relative-header">
                <div>{_.get(this.props.translation, 'accreditation_requests.expose_label')}</div>
            </div>,
            <Table className='accreditation-requests-list-table' key='accreditation-requests-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'accreditation_requests.status_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation_requests.organization_label')}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}</th>
                    <th>{_.get(this.props.translation, 'accreditation_list.level_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation_requests.created_at_label')}</th>
                    <th className='expose-th'>{_.get(this.props.translation, 'accreditation_requests.expose_label')}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationRequestsData()}
                </tbody>
            </Table>
        ]
    };

    renderAccreditationRequestsData = () => {
        return _.map(this.props.data, (request, index) => (
            <tr className="accreditation-requests-list-row" key={index} onClick={this.handleRowClick(request)}>
                <td className='status-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.status_label') + ':'}>
                    <Badge
                        color={STATUS_COLOR[request.status]}>{_.get(this.props.translation, 'accreditation_requests.status.' + request.status)}</Badge>
                </td>
                <td className='org-name-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.organization_label') + ':'}>
                    {request.orgName} ({request.orgDomain})
                </td>
                <td className='accreditation-group-name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.accreditation_group_label) + ':'}>
                    {_.isNil(request.managingOrganizationId) ? request.accreditationGroupName : null}
                </td>
                <td className='level-td'
                    data-th={_.get(this.props.translation, 'accreditation_list.level_label') + ':'}>
                    {_.get(this.props.translation, 'levels.' + request.accreditationData.level)}
                </td>
                <td className='created-at-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.created_at_label') + ':'}>
                    {moment(request.createdAt).format('LL')}
                </td>
                <td className='expose-icon-td'>
                    <IconContainer
                        icon={request.expose ? 'check_box' : 'check_box_outline_blank'}
                        key={request.id + '-expose'}
                        onClick={this.handleChangeExpose(request)}
                        className={'expose-accreditation-request-icon' + (request.expose ? ' exposed' : ' not-exposed')}
                    />
                </td>
                <td className='edit-icon-td'>
                    {
                        request.status === ACCREDITATION_REQUEST_STATUSES.REQUEST_SUBMITTED && _.isNil(request.orgId) && _.isNil(request.accreditationGroupId) ?
                            <IconContainer icon='create'
                                           key={request.id + '-create'}
                                           className="edit-accreditation-request-icon"
                                           title={_.get(this.props.translation, 'accreditation_requests.edit_accreditation_request_label')}/>
                            : <IconContainer icon='visibility'
                                             key={request.id + '-visibility'}
                                             className="edit-accreditation-request-icon"/>
                    }
                </td>
                <td className='remove-icon-td' onClick={this.handleRemoveIconClick(request)}>
                    <IconContainer icon='trash'
                                   key={request.id + '-trash'}
                                   className="trash-accreditation-request-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.remove_accreditation_request_label')}/>
                </td>
            </tr>
        ))
    };

    handleAddButtonClick = () => {
        this.setState({redirect: true});
    };

    handleRowClick = (request) => () => {
        if (request.status === ACCREDITATION_REQUEST_STATUSES.REQUEST_SUBMITTED && _.isNil(request.orgId) && _.isNil(request.accreditationGroupId)) {
            this.setState({selectedAccreditationRequestId: request.id});
        } else {
            this.props.onGetAccreditationRequestData(request.id);
        }
    };

    handleRemoveIconClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({accreditationRequestToRemove: data, successMessage: SUCCESS_MESSAGE_BY_ACTION.REMOVE});
        this.props.onAccreditationRequestRemove();
    };

    handleCloseModal = () => {
        this.setState({accreditationRequestToRemove: null});
    };

    handleChangeExpose = (data) => (e) => {
        e.stopPropagation();

        this.setState({successMessage: SUCCESS_MESSAGE_BY_ACTION.EDIT});
        this.props.onUpdate(data.id, {expose: !data.expose});
    }
}

AccreditationRequestsList.propTypes = {
    translation: PropTypes.object.isRequired,
    data: PropTypes.array,
    accreditationRequest: PropTypes.object,
    onMount: PropTypes.func.isRequired,
    onAccreditationRequestRemove: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onGetAccreditationRequestData: PropTypes.func.isRequired,
    onShowAccreditationRequestModal: PropTypes.func.isRequired
};

export default AccreditationRequestsList;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/accreditationRequestsList/AccreditationRequestsList.js